/* Stampify theme.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const value = (cents / 100);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const m = format.match(placeholder);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toLocaleString('de-DE'); break;
      case 'amount_with_apostrophe_separator': out = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"); break;
      default: out = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return format.replace(placeholder, out);
  }

  function toast(msg, link, linkText) {
    let el = qs('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.innerHTML = '<i class="toast__ic"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg></i><span class="toast__msg"></span>' + (link ? '<a class="toast__link" href="' + link + '">' + linkText + ' →</a>' : '');
    el.querySelector('.toast__msg').textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3500);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = count; el.dataset.count = count; });
  }

  /* ---------- reveal on scroll ---------- */
  const revealEls = qsa('[data-reveal]');
  function reveal() {
    const limit = window.innerHeight * 0.94;
    for (let i = revealEls.length - 1; i >= 0; i--) {
      const el = revealEls[i];
      if (el.getBoundingClientRect().top < limit) { el.classList.add('is-in'); revealEls.splice(i, 1); }
    }
    if (!revealEls.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
  }
  let ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(() => { reveal(); ticking = false; }); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', reveal);
  reveal();

  /* ---------- header: ombra allo scroll ---------- */
  const hdrEl = qs('[data-header]');
  if (hdrEl) {
    const onScrollHeader = () => hdrEl.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ---------- fascia: parallasse leggera ---------- */
  const bands = qsa('.band');
  if (bands.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let queued = false;
    const moveBands = () => {
      bands.forEach(band => {
        const media = qs('.band__media', band);
        if (!media) return;
        const r = band.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        media.style.transform = 'translate3d(0,' + (p * -46).toFixed(1) + 'px,0) scale(1.14)';
      });
      queued = false;
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(moveBands); } }, { passive: true });
    window.addEventListener('resize', moveBands);
    moveBands();
    if ('IntersectionObserver' in window) {
      const bio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); bio.unobserve(e.target); } }), { threshold: 0.25 });
      bands.forEach(b => bio.observe(b));
    } else { bands.forEach(b => b.classList.add('is-in')); }
  } else { bands.forEach(b => b.classList.add('is-in')); }

  /* ---------- drawer menu ---------- */
  const drawer = qs('[data-drawer]');
  if (drawer) {
    qsa('[data-drawer-open]').forEach(b => b.addEventListener('click', () => { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }));
    qsa('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', () => { drawer.removeAttribute('open'); document.body.style.overflow = ''; }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.hasAttribute('open')) { drawer.removeAttribute('open'); document.body.style.overflow = ''; } });
  }

  /* ---------- hero video: sound toggle ---------- */
  qsa('[data-sound-toggle]').forEach(btn => {
    const video = qs('video', btn.closest('[data-hero-media]'));
    const label = qs('[data-sound-label]', btn);
    if (!video) return;
    btn.addEventListener('click', () => {
      const turnOn = video.muted;
      video.muted = !turnOn;
      if (turnOn) { video.currentTime = 0; }
      video.play().catch(() => {});
      btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
      if (label) label.textContent = turnOn ? label.dataset.off : label.dataset.on;
    });
    // when it scrolls out of view with sound on, mute again so it doesn't talk over the page
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting && !video.muted) { video.muted = true; btn.setAttribute('aria-pressed', 'false'); if (label) label.textContent = label.dataset.on; }
      }, { threshold: 0.25 }).observe(video);
    }
  });

  /* ---------- hero video modal + sticky home CTA ---------- */
  const vmodal = qs('[data-video-modal]');
  if (vmodal) {
    const mv = qs('video', vmodal);
    const heroVideo = qs('[data-hero-media] video');
    const open = () => {
      if (typeof vmodal.showModal === 'function') vmodal.showModal(); else vmodal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      if (heroVideo) heroVideo.pause();
      if (mv) { mv.muted = false; mv.currentTime = 0; mv.play().catch(() => {}); }
    };
    const close = () => {
      if (mv) mv.pause();
      if (vmodal.open) vmodal.close(); else vmodal.removeAttribute('open');
      document.body.style.overflow = '';
      if (heroVideo) heroVideo.play().catch(() => {});
    };
    qsa('[data-video-open]').forEach(b => b.addEventListener('click', open));
    qsa('[data-video-close]', vmodal).forEach(b => b.addEventListener('click', close));
    vmodal.addEventListener('click', e => { if (e.target === vmodal) close(); });
    vmodal.addEventListener('close', () => { if (mv) mv.pause(); document.body.style.overflow = ''; });
  }
  const stickyHome = qs('[data-sticky-home]');
  const hero = qs('[data-hero]');
  if (stickyHome && hero && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-home');
    const sizes = qs('#taglie');
    let heroOut = false, sizesIn = false;
    const update = () => stickyHome.classList.toggle('is-visible', heroOut && !sizesIn);
    new IntersectionObserver(en => { heroOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }, { threshold: 0.05 }).observe(hero);
    if (sizes) new IntersectionObserver(en => { sizesIn = en[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(sizes);
  }

  /* ---------- UGC videos: play on click ---------- */
  qsa('[data-ugc]').forEach(item => {
    const video = qs('video', item);
    if (!video) return;
    item.addEventListener('click', () => {
      if (video.paused) { qsa('[data-ugc] video').forEach(v => { if (v !== video) { v.pause(); v.closest('[data-ugc]').classList.remove('is-playing'); } }); video.muted = false; video.play(); item.classList.add('is-playing'); }
      else { video.pause(); item.classList.remove('is-playing'); }
    });
  });

  /* ---------- lazy video autoplay when visible ---------- */
  if ('IntersectionObserver' in window) {
    const vio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        const v = e.target;
        if (e.isIntersecting) { v.play().catch(() => {}); } else if (v.hasAttribute('data-autoplay')) { v.pause(); }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 80px 0px' });
    qsa('video[data-autoplay]').forEach(v => vio.observe(v));
  }

  /* ---------- product form ---------- */
  qsa('[data-product-form]').forEach(section => {
    const form = qs('form[data-product-form-el]', section);
    if (!form) return;
    const productJson = qs('[data-product-json]', section);
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const idInput = qs('input[name="id"]', form);
    const priceEl = qs('[data-price]', section);
    const compareEl = qs('[data-compare-price]', section);
    const saveEl = qs('[data-save]', section);
    const addBtn = qs('[data-add-to-cart]', form);
    const addBtnText = qs('[data-add-to-cart-text]', form);
    const stockEl = qs('[data-stock]', section);
    const stickyPrice = qs('[data-sticky-price]', section);
    const stickyVariant = qs('[data-sticky-variant]', section);
    const optionInputs = qsa('.variant-option input', section);
    const gallery = qs('[data-gallery]', section);

    function externalVariant() {
      const ext = optionInputs.find(i => i.checked && i.dataset.externalVariant);
      if (!ext) return null;
      return { id: parseInt(ext.dataset.externalVariant, 10), title: ext.dataset.externalTitle || 'Coppia', price: parseInt(ext.dataset.externalPrice || '0', 10), compare_at_price: parseInt(ext.dataset.externalCompare || '0', 10) || null, available: true, featured_media: null, options: [], external: true };
    }
    function currentVariant() {
      const ext = externalVariant(); if (ext) return ext;
      const selected = optionInputs.filter(i => i.checked && !i.dataset.externalVariant).map(i => i.value);
      if (!selected.length) return product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];
      return product.variants.find(v => v.options.every((o, i) => o === selected[i])) || null;
    }

    function render(variant) {
      const strings = window.theme.strings;
      if (!variant) {
        addBtn.disabled = true; addBtnText.textContent = strings.unavailable; return;
      }
      idInput.value = variant.id;
      section.classList.toggle('product__form-ext', !!variant.external);
      if (!variant.external) { const url = new URL(window.location); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = saveEl.dataset.template.replace('[amount]', formatMoney(variant.compare_at_price - variant.price)); }
      priceEl && priceEl.closest('.price').classList.toggle('price--sale', !!onSale);
      if (variant.available) { addBtn.disabled = false; addBtnText.textContent = strings.addToCart; }
      else { addBtn.disabled = true; addBtnText.textContent = strings.soldOut; }
      if (stockEl) stockEl.hidden = !variant.available;
      const chip = qs('[data-stock-chip]', section); if (chip) { chip.textContent = variant.available ? (window.theme.strings.stockChip||'Disponibile') : window.theme.strings.soldOut; chip.classList.toggle('is-out', !variant.available); }
      // variant image
      if (gallery && !(render.initial && qs('.gallery__slide--video.is-active', gallery))) {
        const vt = qs('.gallery__thumb[data-variant-id="' + variant.id + '"]', gallery);
        if (vt) vt.click();
        else if (variant.featured_media) { const thumb = qs('.gallery__thumb[data-media-id="' + variant.featured_media.id + '"]', gallery); if (thumb) thumb.click(); }
      }
      // mark unavailable options (single-option products)
      if (product.options.length === 1) {
        optionInputs.forEach(inp => {
          if (inp.dataset.externalVariant) return;
          const v = product.variants.find(vv => vv.option1 === inp.value);
          inp.closest('.variant-option').classList.toggle('is-unavailable', !(v && v.available));
        });
      }
    }

    optionInputs.forEach(i => i.addEventListener('change', () => render(currentVariant())));
    render(currentVariant());

    // quantity
    qsa('.qty', section).forEach(q => {
      const input = qs('input', q);
      qs('[data-qty-minus]', q).addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1) - 1); });
      qs('[data-qty-plus]', q).addEventListener('click', () => { input.value = parseInt(input.value || 1) + 1; });
    });

    // ajax add
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      const original = addBtnText.textContent;
      addBtn.disabled = true; addBtnText.textContent = '…';
      try {
        const fd = new FormData(form);
        const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) { const err = await res.json(); throw new Error(err.description || err.message); }
        const cart = await fetch(window.theme.routes.cart + '.js').then(r => r.json());
        updateCartCount(cart.item_count);
        toast(window.theme.strings.added, window.theme.routes.cart, window.theme.strings.viewCart);
      } catch (err) {
        toast(err.message || 'Errore');
      } finally {
        addBtn.disabled = false; addBtnText.textContent = original;
      }
    });

    // sticky buy bar
    const sticky = qs('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      const sio = new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      });
      sio.observe(form);
      qs('button', sticky).addEventListener('click', () => form.requestSubmit());
    }

    // gallery
    if (gallery) {
      const slides = qsa('.gallery__slide', gallery);
      const thumbs = qsa('.gallery__thumb', gallery);
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('is-active'));
        slides.forEach(x => { x.classList.remove('is-active'); const v = qs('video', x); if (v) v.pause(); });
        t.classList.add('is-active'); slides[i].classList.add('is-active');
        const v = qs('video', slides[i]); if (v) v.play().catch(() => {});
        t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }));
      render.initial = true; render(currentVariant()); render.initial = false; // al primo render il video resta in evidenza
      // swipe
      let x0 = null;
      gallery.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const cur = thumbs.findIndex(t => t.classList.contains('is-active'));
        const next = dx < 0 ? Math.min(cur + 1, thumbs.length - 1) : Math.max(cur - 1, 0);
        thumbs[next] && thumbs[next].click();
      });
    }
  });

  /* ---------- cart page ---------- */
  let cartPage = qs('[data-cart-page]');
  if (cartPage) {
    let busy = false;
    // campi che l'utente puo' aver gia' compilato: vanno conservati quando la sezione
    // viene rigenerata dal server dopo un cambio di quantita'
    const KEEP = 'input[name^="attributes"], textarea[name="note"], [data-invoice-toggle]';
    function snapshot(root) {
      const out = [];
      qsa(KEEP, root).forEach(el => out.push([el.name || el.dataset.invoiceToggle || '', el.type === 'checkbox' ? el.checked : el.value]));
      const note = qs('.cart-summary__note', root);
      out.push(['__noteOpen', note ? note.open : false]);
      return out;
    }
    function restore(root, snap) {
      const map = new Map(snap);
      qsa(KEEP, root).forEach(el => {
        const k = el.name || el.dataset.invoiceToggle || '';
        if (!map.has(k)) return;
        const v = map.get(k);
        if (el.type === 'checkbox') el.checked = !!v; else el.value = v;
      });
      const note = qs('.cart-summary__note', root);
      if (note && map.get('__noteOpen')) note.open = true;
      syncInvoice(root);
    }
    function syncInvoice(root) {
      const t = qs('[data-invoice-toggle]', root), box = qs('[data-invoice-fields]', root);
      if (t && box) box.hidden = !t.checked;
    }
    function fail(root, msg) {
      let e = qs('[data-cart-error]', root);
      if (!e) {
        e = document.createElement('p');
        e.setAttribute('data-cart-error', '');
        e.className = 'cart-error';
        const sum = qs('.cart-summary', root) || root;
        sum.prepend(e);
      }
      e.textContent = msg;
    }
    async function change(line, quantity) {
      if (busy) return;
      busy = true;
      const root = cartPage;
      root.style.opacity = '.6';
      const snap = snapshot(root);
      try {
        const res = await fetch(window.theme.routes.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!res.ok) throw new Error('cart ' + res.status);
        const cart = await res.json();
        updateCartCount(cart.item_count);
        const r2 = await fetch(window.location.pathname + '?section_id=' + root.dataset.sectionId);
        if (!r2.ok) throw new Error('section ' + r2.status);
        const doc = new DOMParser().parseFromString(await r2.text(), 'text/html');
        const fresh = qs('[data-cart-page]', doc);
        if (!fresh) throw new Error('markup');
        root.replaceWith(fresh);
        cartPage = fresh;              // <- senza questo dal secondo click in poi si aggiornava un nodo staccato
        restore(fresh, snap);
        bindCart(fresh);
      } catch (err) {
        root.style.opacity = '';
        fail(root, (root.dataset.errorText || 'Non riesco ad aggiornare il carrello. Riprova.'));
      } finally {
        busy = false;
      }
    }
    function bindCart(root) {
      qsa('[data-line-minus]', root).forEach(b => b.addEventListener('click', () => change(+b.dataset.line, Math.max(0, +b.dataset.qty - 1))));
      qsa('[data-line-plus]', root).forEach(b => b.addEventListener('click', () => change(+b.dataset.line, +b.dataset.qty + 1)));
      qsa('[data-line-remove]', root).forEach(b => b.addEventListener('click', e => { e.preventDefault(); change(+b.dataset.line, 0); }));
      qsa('[data-line-qty]', root).forEach(i => {
        i.addEventListener('change', () => change(+i.dataset.line, Math.max(0, parseInt(i.value || 0))));
        i.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); i.blur(); } });
      });
      const t = qs('[data-invoice-toggle]', root), box = qs('[data-invoice-fields]', root);
      if (t && box) {
        t.addEventListener('change', () => {
          box.hidden = !t.checked;
          if (t.checked) { const i = qs('input', box); if (i) i.focus(); }
          else qsa('input', box).forEach(i => { i.value = ''; });
        });
        syncInvoice(root);
      }
    }
    bindCart(cartPage);
  }

  /* ---------- localization form auto-submit ---------- */
  qsa('[data-localization-form] select').forEach(sel => sel.addEventListener('change', () => sel.form.submit()));

  /* ---------- address forms (customers/addresses) ---------- */
  qsa('[data-address-toggle]').forEach(b => b.addEventListener('click', () => {
    const t = qs(b.dataset.addressToggle); if (t) t.hidden = !t.hidden;
  }));
  qsa('[data-address-delete]').forEach(b => b.addEventListener('click', () => {
    if (!confirm(b.dataset.confirm)) return;
    const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.target;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  }));
  // country/province selectors
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    qsa('[data-address-form]').forEach(f => {
      const id = f.dataset.addressForm;
      new Shopify.CountryProvinceSelector('AddressCountry_' + id, 'AddressProvince_' + id, { hideElement: 'AddressProvinceContainer_' + id });
    });
  }
})();

(function(){var h=document.querySelector('.header');if(!h)return;var set=function(){document.documentElement.style.setProperty('--header-h',h.offsetHeight+'px')};set();window.addEventListener('resize',set);window.addEventListener('load',set)})();

/* ---------- racconto a scorrimento: progresso preciso per gesto ---------- */
(function(){
  var story=document.querySelector('[data-story]'); if(!story) return;
  var steps=[].slice.call(story.querySelectorAll('[data-story-step]'));
  var imgs=[].slice.call(story.querySelectorAll('[data-story-img]'));
  var caps=[].slice.call(story.querySelectorAll('[data-story-cap]'));
  var bars=[].slice.call(story.querySelectorAll('[data-story-bar] i'));
  var counter=story.querySelector('[data-story-counter]');
  var current=-1, ticking=false;
  function pad(n){return (n<9?'0':'')+(n+1)}
  function update(){
    ticking=false;
    var vh=window.innerHeight, best=0, bestT=0;
    steps.forEach(function(s,i){
      var r=s.getBoundingClientRect();
      if(r.top<=vh*0.5){best=i;bestT=Math.max(0,Math.min(1,-r.top/r.height))}
    });
    if(best!==current){
      current=best;
      steps.forEach(function(s,i){s.classList.toggle('is-active',i===best)});
      imgs.forEach(function(m,i){m.classList.toggle('is-active',i===best)});
      caps.forEach(function(c,i){c.classList.toggle('is-active',i===best)});
      imgs.forEach(function(m,i){var v=m.querySelector('video');if(!v)return;if(i===best){v.play().catch(function(){})}else{v.pause()}});
      if(counter) counter.textContent=pad(best);
    }
    bars.forEach(function(b,i){
      var v=i<best?1:(i===best?Math.max(0,Math.min(1,bestT)):0);
      b.style.transform='scaleX('+v+')';
    });
  }
  function onScroll(){ if(!ticking){ticking=true;requestAnimationFrame(update)} }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  update();
})();

/* ---------- date di consegna ---------- */
(function(){
  var el=document.querySelector('[data-delivery]'); if(!el) return;
  function addBiz(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x}
  function fmt(d){return d.toLocaleDateString(document.documentElement.lang||'it',{weekday:'short',day:'numeric',month:'short'}).replace(/\./g,'')}
  var now=new Date(), cutoff=now.getHours()>=14?1:0;
  var ship=addBiz(now,parseInt(el.dataset.ship||'1')+cutoff);
  var a=addBiz(ship,parseInt(el.dataset.min||'1')), b=addBiz(ship,parseInt(el.dataset.max||'2'));
  var o=el.querySelector('[data-delivery-order]'), s=el.querySelector('[data-delivery-ship]'), r=el.querySelector('[data-delivery-arrive]');
  if(o) o.textContent='Oggi';
  if(s) s.textContent=fmt(ship);
  if(r) r.textContent=fmt(a)+(b.getTime()!==a.getTime()?' – '+fmt(b):'');
  var rs=el.querySelector('[data-delivery-arrive-short]'); if(rs) rs.textContent=(b.getTime()!==a.getTime()?fmt(a).replace(/^\S+\s/,'')+'–'+fmt(b).replace(/^\S+\s/,''):fmt(a));
})();

/* ---------- barre fisse: nascoste dove ci sono già i bottoni o vicino al footer ---------- */
(function(){
  var bars=[].slice.call(document.querySelectorAll('.sticky-home,.sticky-buy')); if(!bars.length||!('IntersectionObserver' in window)) return;
  var zones=[].slice.call(document.querySelectorAll('#taglie,.closer,.footer,[data-sticky-hide]')); if(!zones.length) return;
  var visible=new Set();
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting)visible.add(en.target);else visible.delete(en.target)});bars.forEach(function(b){b.classList.toggle('is-hidden',visible.size>0)})},{rootMargin:'0px 0px -20% 0px',threshold:0});
  zones.forEach(function(z){io.observe(z)});
})();

/* ---------- header flottante: indicatore che scorre + nascondi/mostra ---------- */
(function(){
  var nav=document.querySelector('[data-pill-nav]'), ind=nav&&nav.querySelector('[data-pill-indicator]');
  if(nav&&ind){
    var links=[].slice.call(nav.querySelectorAll('a'));
    var current=nav.querySelector('a[aria-current]');
    function moveTo(a){ if(!a){ind.classList.remove('is-on');return} var nr=nav.getBoundingClientRect(),r=a.getBoundingClientRect(); ind.style.left=(r.left-nr.left)+'px'; ind.style.width=r.width+'px'; ind.classList.add('is-on') }
    function reset(){ links.forEach(function(l){l.classList.remove('is-hover')}); moveTo(current) }
    links.forEach(function(a){ a.addEventListener('mouseenter',function(){links.forEach(function(l){l.classList.remove('is-hover')}); a.classList.add('is-hover'); moveTo(a)}); a.addEventListener('focus',function(){moveTo(a)}) });
    nav.addEventListener('mouseleave',reset);
    window.addEventListener('resize',reset);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(reset); else reset();
    setTimeout(reset,300); window.addEventListener('load',reset);
  }
  var h=document.querySelector('.header--autohide'); if(!h) return;
  var last=window.scrollY, ticking=false;
  function upd(){ ticking=false; var y=window.scrollY; var open=document.querySelector('.drawer.is-open'); if(open){h.classList.remove('header--hidden');last=y;return}
    if(y>last+6&&y>140) h.classList.add('header--hidden'); else if(y<last-6||y<140) h.classList.remove('header--hidden'); last=y }
  window.addEventListener('scroll',function(){ if(!ticking){ticking=true;requestAnimationFrame(upd)} },{passive:true});
})();

/* ---------- fascia dati: numeri che contano quando entrano ---------- */
(function(){
  var band=document.querySelector('.facts-band'); if(!band) return;
  var items=[].slice.call(band.querySelectorAll('[data-fact]'));
  items.forEach(function(li){
    var t=li.querySelector('[data-fact-title]'); if(!t) return; var txt=t.textContent.trim(); var forced=li.getAttribute('data-num'); var m=forced?null:txt.match(/(\d+)(%?)/);
    var num=document.createElement('span'); num.className='facts-band__num';
    if(forced){ var fm=forced.match(/^(\d+)(.*)$/); if(fm){num.setAttribute('data-target',fm[1]);num.setAttribute('data-suffix',fm[2]||'');num.textContent='0'+(fm[2]||'')} else {num.textContent=forced;num.setAttribute('data-static','')} }
    else if(m){ num.setAttribute('data-target',m[1]); num.setAttribute('data-suffix',m[2]||''); num.textContent='0'+(m[2]||''); t.textContent=txt.replace(m[0],'').replace(/\s{2,}/g,' ').replace(/^\s*(al|il|a)\s+/i,'').trim()||txt; }
    else { num.textContent='∞'; num.setAttribute('data-static',''); }
    li.insertBefore(num,t);
  });
  function run(){
    band.classList.add('is-in');
    band.querySelectorAll('[data-target]').forEach(function(n){
      var target=parseInt(n.getAttribute('data-target'),10), suf=n.getAttribute('data-suffix')||'', start=null, dur=1400;
      function step(ts){ if(!start) start=ts; var p=Math.min(1,(ts-start)/dur); var e=1-Math.pow(1-p,3); n.textContent=Math.round(target*e)+suf; if(p<1) requestAnimationFrame(step) }
      requestAnimationFrame(step);
    });
  }
  if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ run(); io.disconnect() } },{threshold:.3}); io.observe(band) } else run();
})();

/* ---------- accordion fluido: altezza animata, niente salti di pagina ---------- */
(function(){
  var items=[].slice.call(document.querySelectorAll('.accordion details, details.faq-item'));
  if(!items.length) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  items.forEach(function(d){
    var sum=d.querySelector('summary'); if(!sum) return;
    var body=d.querySelector('.rte, .faq-item__body');
    var anim=null, busy=false;
    function finish(open){ d.open=open; d.classList.remove('is-opening','is-closing'); d.style.height=''; d.style.overflow=''; anim=null; busy=false; }
    sum.addEventListener('click',function(e){
      e.preventDefault(); if(busy||reduce){ if(reduce) d.open=!d.open; return } busy=true;
      var from=d.offsetHeight;
      if(d.open){
        d.classList.add('is-closing'); var to=sum.offsetHeight;
        d.style.height=from+'px'; d.style.overflow='hidden';
        anim=d.animate([{height:from+'px'},{height:to+'px'}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
        anim.onfinish=function(){ finish(false) }; anim.oncancel=function(){ finish(false) };
      } else {
        d.style.height=from+'px'; d.style.overflow='hidden'; d.open=true; d.classList.add('is-opening');
        requestAnimationFrame(function(){
          var to=sum.offsetHeight+(body?body.offsetHeight:0)+1;
          anim=d.animate([{height:from+'px'},{height:to+'px'}],{duration:360,easing:'cubic-bezier(.2,.7,.2,1)'});
          anim.onfinish=function(){ finish(true) }; anim.oncancel=function(){ finish(true) };
        });
      }
    });
  });
})();

/* ---------- barre fisse: tutta la pillola è cliccabile (barra come pulsante) ---------- */
(function(){
  document.querySelectorAll('.sticky-buy,.sticky-home').forEach(function(bar){
    var btn=bar.querySelector('button,a.btn'); if(!btn) return;
    bar.addEventListener('click',function(e){ if(e.target.closest('button,a')) return; btn.click(); });
  });
})();

/* ---------- home speciale: titolo parola per parola + tilt del pannello col mouse ---------- */
(function(){
  var t=document.querySelector('.cine__title'); if(t&&!t.dataset.split){
    var i=0; var walk=function(node){ [].slice.call(node.childNodes).forEach(function(n){
      if(n.nodeType===3){ var frag=document.createDocumentFragment(); n.textContent.split(/(\s+)/).forEach(function(part){ if(!part){return} if(/^\s+$/.test(part)){frag.appendChild(document.createTextNode(part));return} var s=document.createElement('span'); s.className='w'; s.style.setProperty('--i',i++); s.textContent=part; frag.appendChild(s) }); n.parentNode.replaceChild(frag,n) }
      else if(n.nodeType===1&&n.tagName!=='BR'){ if(n.tagName==='EM'){ n.classList.add('w'); n.style.setProperty('--i',i++); } else walk(n) } }) };
    walk(t); t.dataset.split='1';
  }
  var hero=document.querySelector('.cine'), bg=hero&&hero.querySelector('.cine__bg'); if(!hero||!bg) return;
  if(window.matchMedia('(hover:hover) and (min-width:750px)').matches){
    var v=bg.querySelector('video,img'); var raf=null, tx=0, ty=0;
    hero.addEventListener('mousemove',function(e){ var r=hero.getBoundingClientRect(); tx=((e.clientX-r.left)/r.width-.5); ty=((e.clientY-r.top)/r.height-.5); if(!raf) raf=requestAnimationFrame(function(){ raf=null; if(v) v.style.transform='translate3d('+(tx*-10)+'px,'+(ty*-8)+'px,0) rotate('+(tx*1.2)+'deg)'; bg.style.setProperty('--px',tx); bg.style.setProperty('--py',ty); }) });
    hero.addEventListener('mouseleave',function(){ if(v) v.style.transform=''; });
  }
})();

/* ---------- "Scopri Stampify": resta sempre visibile quando la hero esce ---------- */
(function(){
  var src=document.querySelector('[data-discover]'); if(!src||!('IntersectionObserver' in window)) return;
  var fab=document.createElement('a'); fab.className='discover-fab'; fab.href=src.getAttribute('href');
  fab.innerHTML='<i></i><span>'+(src.getAttribute('data-discover-text')||'Scopri Stampify')+'</span><b aria-hidden="true">→</b>';
  document.body.appendChild(fab);
  var heroOut=false, footerIn=false;
  function upd(){ fab.classList.toggle('is-on', heroOut && !footerIn) }
  new IntersectionObserver(function(en){ heroOut=!en[0].isIntersecting; upd() },{threshold:0}).observe(src);
  var foot=document.querySelector('.contact-box, footer.footer');
  if(foot) new IntersectionObserver(function(en){ footerIn=en[0].isIntersecting; upd() },{threshold:0}).observe(foot);
})();

/* ---------- selettore lingua: la scelta manuale vince sul reindirizzamento automatico ---------- */
(function(){
  document.querySelectorAll('form.footer__lang, form.lang-form').forEach(function(f){
    f.addEventListener('submit',function(e){ var b=e.submitter; var v=(b&&b.value)||(f.querySelector('[name=locale_code]')||{}).value||''; if(v) document.cookie='stampify_lang='+v+'; path=/; max-age=31536000; SameSite=Lax'; });
    var sel=f.querySelector('select[name=locale_code]'); if(sel) sel.addEventListener('change',function(){ document.cookie='stampify_lang='+sel.value+'; path=/; max-age=31536000; SameSite=Lax'; f.submit(); });
  });
})();

/* toggle fattura: ora gestito dentro bindCart() cosi' sopravvive al re-render della sezione */
